const sivi = (state) => state.sivi;
const selectedAFDMessages = (state) => state.selectedAFDMessages;

const availablePackages = (context) => context.availablePackages;

const packageMessageLinkOptions = (context) => context.packageMessageLinkOptions;

const linkOptions = (context) => {
  if (context.chosenPackage !== "") {
    return context.linkOptions[context.chosenPackage];
  }
  return {};
};

const chosenPackage = (context) => context.chosenPackage;

const currentPackages = (context) => context.currentPackages;

const selectedCustomer = (context) => context.selectedCustomer;

const selectedCustomerId = (context) => context.selectedCustomerId;
const newCustomerData = (context) => {
  if (Object.keys(context.newCustomerData).length === 0) {
    return false;
  }
  return context.newCustomerData;
};

const foundCustomers = (context) => context.foundCustomers;

const attachmentAgency = (context) => (messageId) => context.attachmentAgencies[messageId];

const linkAttachmentsToAgencyCategory = (context) => context.linkAttachmentsToAgencyCategory;

const perPageOptions = (context) => context.perPageOptions;

const fetchingPaginatedUnprocessedPackageMessages = (context) => context.fetchingPaginatedUnprocessedPackageMessages;
const hasPaginatedUnprocessedPackageMessages = (state) => state.paginatedUnprocessedPackageMessages.length > 0;
const paginatedUnprocessedPackageMessages = (state) => state.paginatedUnprocessedPackageMessages;
const paginatedUnprocessedPackageMessagesCurrentRequestData = (state) => state.paginatedUnprocessedPackageMessagesCurrentRequestData;
const paginatedUnprocessedPackageMessagesOrder = (context) => context.paginatedUnprocessedPackageMessagesOrder;
const paginatedUnprocessedPackageMessagesOrderBy = (context) => context.paginatedUnprocessedPackageMessagesOrderBy;
const paginatedUnprocessedPackageMessagesPage = (context) => context.paginatedUnprocessedPackageMessagesPage;
const paginatedUnprocessedPackageMessagesPerPage = (context) => context.paginatedUnprocessedPackageMessagesPerPage;
const selectedUnprocessedPackageMessages = (state) => state.selectedUnprocessedPackageMessages;
const unprocessedPackageMessageCount = (state) => state.unprocessedPackageMessageCount;
const fetchingPaginatedUnprocessedPolicyMessages = (context) => context.fetchingPaginatedUnprocessedPolicyMessages;
const hasPaginatedUnprocessedPolicyMessages = (state) => state.paginatedUnprocessedPolicyMessages.length > 0;
const paginatedUnprocessedPolicyMessages = (state) => state.paginatedUnprocessedPolicyMessages;
const paginatedUnprocessedPolicyMessagesCurrentRequestData = (state) => state.paginatedUnprocessedPolicyMessagesCurrentRequestData;
const paginatedUnprocessedPolicyMessagesOrder = (context) => context.paginatedUnprocessedPolicyMessagesOrder;
const paginatedUnprocessedPolicyMessagesOrderBy = (context) => context.paginatedUnprocessedPolicyMessagesOrderBy;
const paginatedUnprocessedPolicyMessagesPage = (context) => context.paginatedUnprocessedPolicyMessagesPage;
const paginatedUnprocessedPolicyMessagesPerPage = (context) => context.paginatedUnprocessedPolicyMessagesPerPage;
const selectedUnprocessedPolicyMessages = (state) => state.selectedUnprocessedPolicyMessages;
const unprocessedPolicyMessageCount = (state) => state.unprocessedPolicyMessageCount;

const getPackageMessageFilters = (state) => state.packageMessageFilters;

const getPolicyMessageFilters = (state) => state.policyMessageFilters;

export default {
  currentPackages,
  sivi,
  selectedAFDMessages,
  availablePackages,
  chosenPackage,
  packageMessageLinkOptions,
  linkOptions,
  selectedCustomer,
  selectedCustomerId,
  newCustomerData,
  foundCustomers,
  attachmentAgency,
  linkAttachmentsToAgencyCategory,

  perPageOptions,

  fetchingPaginatedUnprocessedPackageMessages,
  hasPaginatedUnprocessedPackageMessages,
  paginatedUnprocessedPackageMessages,
  paginatedUnprocessedPackageMessagesCurrentRequestData,
  paginatedUnprocessedPackageMessagesOrder,
  paginatedUnprocessedPackageMessagesOrderBy,
  paginatedUnprocessedPackageMessagesPage,
  paginatedUnprocessedPackageMessagesPerPage,
  selectedUnprocessedPackageMessages,
  unprocessedPackageMessageCount,

  fetchingPaginatedUnprocessedPolicyMessages,
  hasPaginatedUnprocessedPolicyMessages,
  paginatedUnprocessedPolicyMessages,
  paginatedUnprocessedPolicyMessagesCurrentRequestData,
  paginatedUnprocessedPolicyMessagesOrder,
  paginatedUnprocessedPolicyMessagesOrderBy,
  paginatedUnprocessedPolicyMessagesPage,
  paginatedUnprocessedPolicyMessagesPerPage,
  selectedUnprocessedPolicyMessages,
  unprocessedPolicyMessageCount,

  getPackageMessageFilters,
  getPolicyMessageFilters,
};
